export const VERTECS = [
  174, 156, 134, 247, 34, 8, 383, 399, 363, 264, 467, 250, 309, 416, 325, 79,
  96, 192, 357, 390, 265, 128, 35, 163, 369, 265, 390, 140, 163, 35, 268, 1,
  303, 38, 73, 1, 12, 303, 1, 12, 1, 73, 350, 452, 351, 121, 122, 232, 453, 351,
  452, 233, 232, 122, 268, 303, 270, 38, 40, 73, 304, 270, 303, 74, 73, 40, 358,
  344, 351, 129, 122, 115, 278, 351, 344, 48, 115, 122, 351, 453, 358, 122, 129,
  233, 454, 358, 453, 234, 233, 129, 300, 334, 298, 70, 68, 105, 333, 298, 334,
  104, 105, 68, 176, 153, 397, 176, 172, 153, 378, 397, 153, 149, 153, 172, 382,
  385, 383, 155, 156, 158, 399, 383, 385, 174, 158, 156, 281, 348, 331, 51, 102,
  119, 349, 331, 348, 120, 119, 102, 270, 304, 271, 40, 41, 74, 305, 271, 304,
  75, 74, 41, 10, 337, 152, 10, 152, 108, 338, 152, 337, 109, 108, 152, 345,
  279, 361, 116, 132, 49, 280, 361, 279, 50, 49, 132, 263, 432, 419, 33, 195,
  212, 425, 419, 432, 205, 212, 195, 305, 409, 271, 75, 41, 185, 410, 271, 409,
  186, 185, 41, 273, 311, 408, 43, 184, 81, 416, 408, 311, 192, 81, 184, 323,
  271, 411, 93, 187, 41, 410, 411, 271, 186, 41, 187, 348, 450, 349, 119, 120,
  230, 451, 349, 450, 231, 230, 120, 435, 433, 431, 215, 211, 213, 423, 431,
  433, 203, 213, 211, 314, 315, 19, 84, 19, 85, 18, 19, 315, 18, 85, 19, 308,
  376, 307, 78, 77, 147, 292, 307, 376, 62, 147, 77, 260, 388, 261, 30, 31, 161,
  389, 261, 388, 162, 161, 31, 287, 415, 385, 57, 158, 191, 399, 385, 415, 174,
  191, 158, 419, 425, 407, 195, 183, 205, 336, 407, 425, 107, 205, 183, 368,
  417, 365, 139, 136, 193, 435, 365, 417, 215, 193, 136, 392, 424, 328, 166, 99,
  204, 359, 328, 424, 130, 204, 99, 299, 302, 285, 69, 55, 72, 252, 285, 302,
  22, 72, 55, 5, 276, 6, 5, 6, 46, 282, 6, 276, 52, 46, 6, 255, 374, 254, 25,
  24, 145, 375, 254, 374, 146, 145, 24, 321, 322, 308, 91, 78, 92, 376, 308,
  322, 147, 92, 78, 281, 426, 412, 51, 188, 206, 428, 412, 426, 208, 206, 188,
  422, 314, 201, 202, 201, 84, 19, 201, 314, 19, 84, 201, 336, 322, 407, 107,
  183, 92, 406, 407, 322, 182, 92, 183, 406, 322, 405, 182, 181, 92, 321, 405,
  322, 91, 92, 181, 18, 315, 17, 18, 17, 85, 316, 17, 315, 86, 85, 17, 426, 267,
  427, 206, 207, 37, 424, 427, 267, 204, 37, 207, 370, 397, 401, 141, 177, 172,
  378, 401, 397, 149, 172, 177, 392, 270, 323, 166, 93, 40, 271, 323, 270, 41,
  40, 93, 418, 466, 414, 194, 190, 246, 465, 414, 466, 245, 246, 190, 258, 259,
  387, 28, 160, 29, 386, 387, 259, 159, 29, 160, 261, 389, 468, 31, 248, 162,
  467, 468, 389, 247, 162, 248, 249, 457, 420, 4, 197, 237, 400, 420, 457, 175,
  237, 197, 334, 299, 333, 105, 104, 69, 285, 333, 299, 55, 69, 104, 286, 9,
  418, 56, 194, 9, 169, 418, 9, 169, 9, 194, 341, 262, 347, 112, 118, 32, 449,
  347, 262, 229, 32, 118, 286, 418, 442, 56, 222, 194, 414, 442, 418, 190, 194,
  222, 328, 461, 327, 99, 98, 241, 329, 327, 461, 100, 241, 98, 278, 356, 330,
  48, 101, 127, 372, 330, 356, 143, 127, 101, 310, 393, 439, 80, 219, 167, 440,
  439, 393, 220, 167, 219, 382, 383, 257, 155, 27, 156, 342, 257, 383, 113, 156,
  27, 361, 280, 421, 132, 199, 50, 430, 421, 280, 210, 50, 199, 366, 365, 380,
  137, 151, 136, 395, 380, 365, 170, 136, 151, 356, 278, 438, 127, 218, 48, 344,
  438, 278, 115, 48, 218, 444, 445, 283, 224, 53, 225, 284, 283, 445, 54, 225,
  53, 282, 276, 364, 52, 135, 46, 441, 364, 276, 221, 46, 135, 432, 263, 396,
  212, 171, 33, 370, 396, 263, 141, 33, 171, 338, 300, 339, 109, 110, 70, 298,
  339, 300, 68, 70, 110, 336, 274, 322, 107, 92, 44, 376, 322, 274, 147, 44, 92,
  349, 451, 350, 120, 121, 231, 452, 350, 451, 232, 231, 121, 468, 360, 343,
  248, 114, 131, 447, 343, 360, 227, 131, 114, 283, 284, 335, 53, 106, 54, 294,
  335, 284, 64, 54, 106, 251, 459, 463, 21, 243, 239, 462, 463, 459, 242, 239,
  243, 277, 354, 301, 47, 71, 125, 384, 301, 354, 157, 125, 71, 326, 293, 325,
  97, 96, 63, 309, 325, 293, 79, 63, 96, 284, 277, 294, 54, 64, 47, 301, 294,
  277, 71, 47, 64, 448, 265, 346, 228, 117, 35, 373, 346, 265, 144, 35, 117,
  353, 346, 347, 124, 118, 117, 341, 347, 346, 112, 117, 118, 2, 20, 275, 2, 45,
  20, 355, 275, 20, 126, 20, 45, 249, 282, 457, 4, 237, 52, 364, 457, 282, 135,
  52, 237, 426, 427, 428, 206, 208, 207, 437, 428, 427, 217, 207, 208, 381, 382,
  253, 154, 23, 155, 257, 253, 382, 27, 155, 23, 392, 394, 270, 166, 40, 168,
  268, 270, 394, 38, 168, 40, 200, 429, 201, 200, 201, 209, 422, 201, 429, 202,
  209, 201, 331, 330, 267, 102, 37, 101, 372, 267, 330, 143, 101, 37, 423, 433,
  274, 203, 44, 213, 288, 274, 433, 58, 213, 44, 291, 251, 329, 61, 100, 21,
  463, 329, 251, 243, 21, 100, 259, 287, 386, 29, 159, 57, 385, 386, 287, 158,
  57, 159, 343, 447, 354, 114, 125, 227, 266, 354, 447, 36, 227, 125, 258, 387,
  260, 28, 30, 160, 388, 260, 387, 161, 160, 30, 431, 423, 432, 211, 212, 203,
  425, 432, 423, 205, 203, 212, 446, 343, 277, 226, 47, 114, 354, 277, 343, 125,
  114, 47, 425, 423, 336, 205, 107, 203, 274, 336, 423, 44, 203, 107, 307, 293,
  308, 77, 78, 63, 326, 308, 293, 97, 63, 78, 367, 448, 353, 138, 124, 228, 346,
  353, 448, 117, 228, 124, 303, 269, 304, 73, 74, 39, 272, 304, 269, 42, 39, 74,
  372, 359, 267, 143, 37, 130, 424, 267, 359, 204, 130, 37, 328, 295, 461, 99,
  241, 65, 456, 461, 295, 236, 65, 241, 295, 332, 279, 65, 49, 103, 280, 279,
  332, 50, 103, 49, 304, 272, 305, 74, 75, 42, 273, 305, 272, 43, 42, 75, 428,
  437, 435, 208, 215, 217, 433, 435, 437, 213, 217, 215, 305, 273, 409, 75, 185,
  43, 408, 409, 273, 184, 43, 185, 395, 431, 396, 170, 171, 211, 432, 396, 431,
  212, 211, 171, 396, 370, 379, 171, 150, 141, 401, 379, 370, 177, 141, 150,
  297, 335, 300, 67, 70, 106, 334, 300, 335, 105, 106, 70, 418, 169, 352, 194,
  123, 169, 7, 352, 169, 7, 169, 123, 281, 412, 353, 51, 124, 188, 377, 353,
  412, 148, 188, 124, 320, 321, 326, 90, 97, 91, 308, 326, 321, 78, 91, 97, 286,
  296, 337, 56, 108, 66, 297, 337, 296, 67, 66, 108, 405, 321, 404, 181, 180,
  91, 320, 404, 321, 90, 91, 180, 331, 349, 330, 102, 101, 120, 350, 330, 349,
  121, 120, 101, 335, 294, 334, 106, 105, 64, 299, 334, 294, 69, 64, 105, 324,
  455, 367, 94, 138, 235, 448, 367, 455, 228, 235, 138, 17, 316, 16, 17, 16, 86,
  317, 16, 316, 87, 86, 16, 430, 280, 359, 210, 130, 50, 332, 359, 280, 103, 50,
  130, 16, 317, 15, 16, 15, 87, 318, 15, 317, 88, 87, 15, 9, 286, 10, 9, 10, 56,
  337, 10, 286, 108, 56, 10, 330, 350, 278, 101, 48, 121, 351, 278, 350, 122,
  121, 48, 253, 254, 381, 23, 154, 24, 375, 381, 254, 146, 24, 154, 403, 404,
  319, 179, 89, 180, 320, 319, 404, 90, 180, 89, 352, 7, 420, 123, 197, 7, 198,
  420, 7, 198, 7, 197, 325, 319, 326, 96, 97, 89, 320, 326, 319, 90, 89, 97,
  398, 368, 366, 173, 137, 139, 365, 366, 368, 136, 139, 137, 289, 436, 398, 59,
  173, 216, 368, 398, 436, 139, 216, 173, 439, 440, 345, 219, 116, 220, 279,
  345, 440, 49, 220, 116, 272, 312, 273, 42, 43, 82, 311, 273, 312, 81, 82, 43,
  6, 282, 196, 6, 196, 52, 249, 196, 282, 4, 52, 196, 274, 288, 376, 44, 147,
  58, 292, 376, 288, 62, 58, 147, 397, 429, 176, 172, 176, 209, 200, 176, 429,
  200, 209, 176, 269, 313, 272, 39, 42, 83, 312, 272, 313, 82, 83, 42, 445, 446,
  284, 225, 54, 226, 277, 284, 446, 47, 226, 54, 255, 340, 374, 25, 145, 111,
  391, 374, 340, 164, 111, 145, 296, 283, 297, 66, 67, 53, 335, 297, 283, 106,
  53, 67, 347, 449, 348, 118, 119, 229, 450, 348, 449, 230, 229, 119, 455, 357,
  448, 235, 228, 128, 265, 448, 357, 35, 128, 228, 337, 297, 338, 108, 109, 67,
  300, 338, 297, 70, 67, 109, 152, 338, 11, 152, 11, 109, 339, 11, 338, 110,
  109, 11, 279, 440, 295, 49, 65, 220, 456, 295, 440, 236, 220, 65, 408, 416,
  293, 184, 63, 192, 309, 293, 416, 79, 192, 63, 359, 372, 430, 130, 210, 143,
  356, 430, 372, 127, 143, 210, 346, 373, 341, 117, 112, 144, 266, 341, 373, 36,
  144, 112, 389, 391, 467, 162, 247, 164, 250, 467, 391, 8, 164, 247, 353, 347,
  281, 124, 51, 118, 348, 281, 347, 119, 118, 51, 296, 443, 283, 66, 53, 223,
  444, 283, 443, 224, 223, 53, 20, 95, 355, 20, 126, 95, 371, 355, 95, 142, 95,
  126, 296, 286, 443, 66, 223, 56, 442, 443, 286, 222, 56, 223, 420, 198, 249,
  197, 4, 198, 196, 249, 198, 196, 198, 4, 360, 264, 256, 131, 26, 34, 250, 256,
  264, 8, 34, 26, 276, 275, 441, 46, 221, 45, 458, 441, 275, 238, 45, 221, 301,
  384, 302, 71, 72, 157, 369, 302, 384, 140, 157, 72, 418, 352, 466, 194, 246,
  123, 413, 466, 352, 189, 123, 246, 467, 264, 468, 247, 248, 34, 360, 468, 264,
  131, 34, 248, 390, 252, 369, 163, 140, 22, 302, 369, 252, 72, 22, 140, 375,
  387, 381, 146, 154, 160, 386, 381, 387, 159, 160, 154, 380, 395, 379, 151,
  150, 170, 396, 379, 395, 171, 170, 150, 352, 420, 413, 123, 189, 197, 400,
  413, 420, 175, 197, 189, 427, 323, 437, 207, 217, 93, 411, 437, 323, 187, 93,
  217, 388, 374, 389, 161, 162, 145, 391, 389, 374, 164, 145, 162, 394, 327,
  165, 168, 165, 98, 3, 165, 327, 3, 98, 165, 355, 371, 462, 126, 242, 142, 463,
  462, 371, 243, 142, 242, 1, 268, 165, 1, 165, 38, 394, 165, 268, 168, 38, 165,
  12, 13, 303, 12, 73, 13, 269, 303, 13, 39, 13, 73, 387, 375, 388, 160, 161,
  146, 374, 388, 375, 145, 146, 161, 13, 14, 269, 13, 39, 14, 313, 269, 14, 83,
  14, 39, 294, 301, 299, 64, 69, 71, 302, 299, 301, 72, 71, 69, 341, 266, 262,
  112, 32, 36, 447, 262, 266, 227, 36, 32, 381, 386, 382, 154, 155, 159, 385,
  382, 386, 158, 159, 155, 281, 331, 426, 51, 206, 102, 267, 426, 331, 37, 102,
  206, 424, 392, 427, 204, 207, 166, 323, 427, 392, 93, 166, 207, 430, 356, 421,
  210, 199, 127, 438, 421, 356, 218, 127, 199, 392, 328, 394, 166, 168, 99, 327,
  394, 328, 98, 99, 168, 458, 439, 441, 238, 221, 219, 345, 441, 439, 116, 219,
  221, 383, 363, 342, 156, 113, 134, 464, 342, 363, 244, 134, 113, 458, 462,
  460, 238, 240, 242, 459, 460, 462, 239, 242, 240, 435, 431, 365, 215, 136,
  211, 395, 365, 431, 170, 211, 136, 415, 464, 399, 191, 174, 244, 363, 399,
  464, 134, 244, 174, 263, 429, 370, 33, 141, 209, 397, 370, 429, 172, 209, 141,
  458, 275, 462, 238, 242, 45, 355, 462, 275, 126, 45, 242, 317, 404, 318, 87,
  88, 180, 403, 318, 404, 179, 180, 88, 316, 405, 317, 86, 87, 181, 404, 317,
  405, 180, 181, 87, 315, 406, 316, 85, 86, 182, 405, 316, 406, 181, 182, 86,
  314, 407, 315, 84, 85, 183, 406, 315, 407, 182, 183, 85, 419, 407, 422, 195,
  202, 183, 314, 422, 407, 84, 183, 202, 367, 402, 324, 138, 94, 178, 362, 324,
  402, 133, 178, 94, 409, 408, 307, 185, 77, 184, 293, 307, 408, 63, 184, 77,
  409, 307, 410, 185, 186, 77, 292, 410, 307, 62, 77, 186, 411, 410, 288, 187,
  58, 186, 292, 288, 410, 62, 186, 58, 437, 411, 433, 217, 213, 187, 288, 433,
  411, 58, 187, 213, 435, 417, 428, 215, 208, 193, 412, 428, 417, 188, 193, 208,
  265, 369, 373, 35, 144, 140, 384, 373, 369, 157, 140, 144, 458, 460, 439, 238,
  219, 240, 310, 439, 460, 80, 240, 219, 353, 377, 367, 124, 138, 148, 402, 367,
  377, 178, 148, 138, 5, 2, 276, 5, 46, 2, 275, 276, 2, 45, 2, 46, 429, 263,
  422, 209, 202, 33, 419, 422, 263, 195, 33, 202, 328, 359, 295, 99, 65, 130,
  332, 295, 359, 103, 130, 65, 368, 436, 417, 139, 193, 216, 434, 417, 436, 214,
  216, 193, 456, 440, 290, 236, 60, 220, 393, 290, 440, 167, 220, 60, 329, 463,
  327, 100, 98, 243, 371, 327, 463, 142, 243, 98, 327, 371, 3, 98, 3, 142, 95,
  3, 371, 95, 142, 3, 461, 456, 306, 241, 76, 236, 290, 306, 456, 60, 236, 76,
  449, 340, 450, 229, 230, 111, 255, 450, 340, 25, 111, 230, 262, 447, 256, 32,
  26, 227, 360, 256, 447, 131, 227, 26, 450, 255, 451, 230, 231, 25, 254, 451,
  255, 24, 25, 231, 451, 254, 452, 231, 232, 24, 253, 452, 254, 23, 24, 232,
  452, 253, 453, 232, 233, 23, 257, 453, 253, 27, 23, 233, 257, 342, 453, 27,
  233, 113, 454, 453, 342, 234, 113, 233, 414, 465, 415, 190, 191, 245, 464,
  415, 465, 244, 245, 191, 442, 414, 287, 222, 57, 190, 415, 287, 414, 191, 190,
  57, 442, 287, 443, 222, 223, 57, 259, 443, 287, 29, 57, 223, 443, 259, 444,
  223, 224, 29, 258, 444, 259, 28, 29, 224, 445, 444, 260, 225, 30, 224, 258,
  260, 444, 28, 224, 30, 260, 261, 445, 30, 225, 31, 446, 445, 261, 226, 31,
  225, 261, 468, 446, 31, 226, 248, 343, 446, 468, 114, 248, 226, 251, 310, 459,
  21, 239, 80, 460, 459, 310, 240, 80, 239, 291, 306, 393, 61, 167, 76, 290,
  393, 306, 60, 76, 167, 461, 306, 329, 241, 100, 76, 291, 329, 306, 61, 76,
  100, 377, 434, 402, 148, 178, 214, 436, 402, 434, 216, 214, 178, 251, 291,
  310, 21, 80, 61, 393, 310, 291, 167, 61, 80, 412, 417, 377, 188, 148, 193,
  434, 377, 417, 214, 193, 148, 342, 464, 454, 113, 234, 244, 465, 454, 464,
  245, 244, 234, 454, 465, 358, 234, 129, 245, 466, 358, 465, 246, 245, 129,
  413, 344, 466, 189, 246, 115, 358, 466, 344, 129, 115, 246, 438, 344, 400,
  218, 175, 115, 413, 400, 344, 189, 115, 175, 364, 441, 361, 135, 132, 221,
  345, 361, 441, 116, 221, 132, 457, 421, 400, 237, 175, 199, 438, 400, 421,
  218, 199, 175, 457, 364, 421, 237, 199, 135, 361, 421, 364, 132, 135, 199,
  362, 402, 289, 133, 59, 178, 436, 289, 402, 216, 178, 59, 354, 266, 384, 125,
  157, 36, 373, 384, 266, 144, 36, 157, 256, 250, 340, 26, 111, 8, 391, 340,
  250, 164, 8, 111, 262, 256, 449, 32, 229, 26, 340, 449, 256, 111, 26, 229, 15,
  318, 14, 15, 14, 88, 313, 14, 318, 83, 88, 14, 318, 403, 313, 88, 83, 179,
  312, 313, 403, 82, 179, 83, 403, 319, 312, 179, 82, 89, 311, 312, 319, 81, 89,
  82, 319, 325, 311, 89, 81, 96, 416, 311, 325, 192, 96, 81,
];
